export var VERSION = '1.22.3';
//# sourceMappingURL=version.js.map